import axios from 'axios';
import config from './config';

// Blog voice (CEL-3260, contract agent_docs/blog_voice/BLOG_VOICE_CONTRACT.md §6). PUBLIC endpoints: no auth interceptor, the
// call runs at app boot before Firebase resolves and for signed-out readers. Same-origin in production, so the session cookie
// (when there is one) still rides along and the server's spoofing guard can see it.
const blogVoiceApi = axios.create({
  baseURL: config.API_BASE_URL + '/cellcog',
});

// The hire page was opened from a blog call's "Start this" (stamps the session's start_this_at once, server-side idempotent).
export const postBlogVoiceStartThis = (sessionId) =>
  blogVoiceApi.post(`/public/blog-voice/sessions/${encodeURIComponent(sessionId)}/start-this`, {});

export default blogVoiceApi;
